// AUTO-GENERATED by generate-zod-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { z } from 'zod'

export const userSchema = z.object({
  id: z.string().max(100),
  userId: z.string().max(100).optional(),
  createdAt: z.string().max(200).datetime(),
  updatedAt: z.string().max(200).datetime(),
  metadata: z.record(z.string(), z.unknown()).optional(),
  extended: z.record(z.string(), z.unknown()).optional(),
  name: z.string().max(500),
  email: z.string().max(200).optional(),
  authUserId: z.string().max(100).optional(),
  timezone: z.string().max(200).optional(),
  archived: z.boolean(),
  onboarded: z.boolean(),
  avatarUrl: z.string().max(500).optional(),
  role: z.string().max(50).optional(),
  tenantId: z.string().max(100).optional(),
})

export type UserInput = z.infer<typeof userSchema>
